import { appEnvironment } from '@benzinga/utils';

export const getCanonicalUrl = (node: {
  nodeId?: number;
  NodeID?: string | number;
  canonicalPath?: string;
  CanonicalPath?: string;
}): string => {
  const canonicalPath = node?.canonicalPath || node?.CanonicalPath;
  const nodeId = node?.nodeId || node?.NodeID;
  let articleUrl = `https://www.benzinga.com/article/${nodeId}`;
  if (canonicalPath?.match(/https:\/\/[A-z]+.benzinga.com/)) {
    articleUrl = canonicalPath;
  } else if (canonicalPath) {
    articleUrl = `${appEnvironment().config().url}/${canonicalPath?.trim()}`;
  }
  return articleUrl;
};

const NUMERIC_SEGMENT = /^\d+$/;

export const extractArticleNodeIdFromHref = (href: string): number | null => {
  try {
    const url = new URL(href, 'https://www.benzinga.com');
    const segments = url.pathname.split('/').filter(Boolean);
    let best: string | null = null;
    for (const segment of segments) {
      if (NUMERIC_SEGMENT.test(segment) && (!best || segment.length > best.length)) {
        best = segment;
      }
    }
    return best !== null ? Number(best) : null;
  } catch {
    return null;
  }
};
